import { Component } from '@angular/core';
import * as Chartist from 'chartist';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { default as _rollupMoment, Moment,} from 'moment';
import { FormControl } from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import { Dashboard } from '../../models/Dashboard';
import { environment } from 'environments/environment';

const moment = _rollupMoment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-kpi8-dashboard',
  templateUrl: './kpi8.component.html',
  styleUrls: ['./kpi8.component.css'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class Kpi8Component{

  date = new FormControl(moment());
  totalCartera:any=0;
  dataactual:any;
  disponible:any = 20.00;
  monedaElement : any = 1255;
  loading: boolean = false;
  disable: boolean = false;
  simbolo : any;
  datarandom: any={
    '202411':
    {
      '1255':[{
        dia:"Ene",
        cartera:0.5,
        util:15.3
      },{ 
        dia:"Feb",
        cartera:0.75,
        util:16.8 
      },{ 
        dia:"Mar",
        cartera:1.5,
        util:16.9 
      },{ 
        dia:"Abr",
        cartera:1.2,
        util:15.8 
      },{ 
        dia:"May",
        cartera:0.8,
        util:17.3 
      },{ 
        dia:"Jun",
        cartera:1.3,
        util:18.9 
      },{ 
        dia:"Jul",
        cartera:1.2,
        util:20 
      },{ 
        dia:"Ago",
        cartera:2.1,
        util:20.9 
      },{ 
        dia:"Sep",
        cartera:1.5,
        util:21 
      },{ 
        dia:"Oct",
        cartera:0.7,
        util:20.8 
      },{ 
        dia:"Nov",
        cartera:1.2,
        util:20.75 
      },{ 
        dia:"Dic",
        cartera:0,
        util:20.75 
      }],
      '1447':[{
        dia:"Ene",
        cartera:0.1,
        util:15.5,
        acum:0
      },{ 
        dia:"Feb",
        cartera:0.15,
        util:16.8 
      },{ 
        dia:"Mar",
        cartera:0.12,
        util:18.56 
      },{ 
        dia:"Abr",
        cartera:0.16,
        util:19.7 
      },{ 
        dia:"May",
        cartera:0.18,
        util:20.8 
      },{ 
        dia:"Jun",
        cartera:0.20,
        util:21.65 
      },{ 
        dia:"Jul",
        cartera:0.35,
        util:22.58 
      },{ 
        dia:"Ago",
        cartera:0.39,
        util:23.5 
      },{ 
        dia:"Sep",
        cartera:0.41,
        util:25.45 
      },{ 
        dia:"Oct",
        cartera:0.53,
        util:25.88 
      },{ 
        dia:"Nov",
        cartera:0.45,
        util:26.4 
      },{ 
        dia:"Dic",
        cartera:0,
        util:26.4 
      }]
    }
  }
    
  ;
  constructor(private dashboardService:DashboardService,private datePipe: DatePipe) { }
  
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
    //this.obtenerDashboardFecha();
  }
  startAnimationForLineChart(chart){
      let seq: any, delays: any, durations: any;
      seq = 0;
      delays = 80;
      durations = 500;

      chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if(data.type === 'point') {
              seq++;
              data.element.animate({
                opacity: {
                  begin: seq * delays,
                  dur: durations,
                  from: 0,
                  to: 1,
                  easing: 'ease'
                }
              });
          }
      });

      seq = 0;
  };
  startAnimationForBarChart(chart){
      let seq2: any, delays2: any, durations2: any;

      seq2 = 0;
      delays2 = 80;
      durations2 = 500;
      chart.on('draw', function(data) {
        if(data.type === 'bar'){
            seq2++;
            data.element.animate({
              opacity: {
                begin: seq2 * delays2,
                dur: durations2,
                from: 0,
                to: 1,
                easing: 'ease'
              }
            });
        }
      });

      seq2 = 0;
  };
  ngOnInit() {
       
      this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);

       

  }
  sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  async getrandom(periodo,monedaElement){
    this.loading = true;
    await this.sleep(3000);
    this.loading = false; 
    var datawebsiteViewsChart:any={labels: [],series:[]};
    var datawebsiteViewsChart2:any={labels: [],series:[]};
    this.dataactual = this.datarandom[periodo][monedaElement];
    this.simbolo = (this.monedaElement == 1447)? '(MM)':'(k)';    
    let smb = this.simbolo;
    let serie1: any=[]
    let serie2: any=[]
    var acumtotal:any=0;
    this.dataactual.forEach(element => { 
      acumtotal+= element.cartera;
    });
    
    for (let index = 0; index < this.dataactual.length; index++) { 
       this.dataactual[index].util = (this.dataactual[index].cartera/acumtotal*100);
    } 
    this.dataactual.forEach(element => {
      datawebsiteViewsChart.labels.push(element.dia);
      datawebsiteViewsChart2.labels.push(element.dia);
      this.totalCartera+= element.cartera;
      serie1.push(element.cartera);
      serie2.push(element.util);
    });
    datawebsiteViewsChart.series.push(serie1);
    datawebsiteViewsChart2.series.push(serie2);
     
    

    var optionswebsiteViewsChart = {
        axisX: {
            showGrid: false
        },
        axisY: {   
          labelInterpolationFnc: function(value) {
            return Math.floor(value) + smb; 
          },
          high: 10
        },
        low: 0, 
        height: 400,
        chartPadding: { top: 5, right: 5, bottom: 5, left: 20}
    };
    
    var optionswebsiteViewsChart2 = {
      axisX: {
          showGrid: false
      },axisY: {   
        labelInterpolationFnc: function(value) {
          return Math.floor(value) + '%'; 
        },
        high: 100
      },
      low: 0, 
      height: 400,
      chartPadding: { top: 5, right: 5, bottom: 5, left: 20}
  };
    var responsiveOptions: any[] = [ 
       
    ];
    var websiteViewsChart = new Chartist.Bar('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart, responsiveOptions);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart);

    
    var websiteViewsChart2 = new Chartist.Line('#websiteViewsChart2', datawebsiteViewsChart2, optionswebsiteViewsChart2, responsiveOptions);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart2);
  }
  tipoMoneda(event){
    this.monedaElement = event;
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
  }
}
